// Author YuJiaBei
// Date 2021-06-07 15:49:36

import * as model from "@/model/sithMes/prd/SithMesProProjectPlanDetailDepPpddModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesProProjectPlanDetailDepPpdd(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .buildStore()
